<template>
  <div>
    <div style="display: flex; justify-content: space-between">
      <h2 class="page-title">Договора</h2>
    </div>
    <el-card style="margin-bottom: 15px;">
      <el-row type="flex" class="row-bg" justify="space-between">
        <div>
          <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="По"
              start-placeholder="Начало"
              end-placeholder="Конец"
              @change="getData"
              :picker-options="pickerOptions"
              :default-value="defaultDateRange">
          </el-date-picker>
        </div>
<!--        <el-col :span="6">-->
<!--          <el-input v-model="search" placeholder="Поиск"></el-input>-->
<!--        </el-col>-->
      </el-row>
    </el-card>
    <el-card>
      <el-table
          v-loading="isLoading"
          :data="data"
          @sort-change="sortChange"
          @row-click="openDocument($event)"
          :default-sort="{}"
          size="small"
          style="width: 100%">
        <el-table-column
            prop="companyName"
            label="Контрагент"
            sortable
        >
          <template slot-scope="scope">
            <span>{{ scope.row.companyName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="agreementNumber"
            label="№ договора"
            sortable
        >
          <template slot-scope="scope">
            <span>{{ scope.row.agreementNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="agreementName"
            label="Наименование договора"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.agreementName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="Сумма"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="registryDate"
            label="Дата регистрации"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.registryDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="agreementCreatedDate"
            label="Дата создания"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.agreementCreatedDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createdAt"
            label="Дата создания"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.created }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 25, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import blockchainApi from '@/modules/api/blockchain'
import authorizationAPI from '@/modules/api/authorization'
import date from '@/modules/directories/date/date'
import { canCreateTickets } from '@/modules/permissions/permissions'
import { endOfDay, format, startOfMonth } from 'date-fns'
import documentNotificationsStore from '@/modules/notifications/documentNotificationsStore'

export default {
  name: 'CompanyAgreement',
  components: {
  },
  data () {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1)
    const firstDayOfPreviousMonth = new Date(currentYear, currentMonth - 1, 1)
    const currentData = new Date()
    const fromDate = startOfMonth(currentData)
    const toDate = currentData
    return {
      isLoading: false,
      data: [],
      createDialogVisible: false,
      creationDocType: '',
      currentPage: 1,
      pageSize: 10,
      totalElements: 0,
      sortBy: '',
      orderBy: '',
      search: '',
      notificantionCount: 0,
      pickerOptions: {
        shortcuts: [{
          text: 'Неделя',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Месяц',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '3 месяца',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultDateRange: [firstDayOfPreviousMonth, firstDayOfCurrentMonth],
      value1: '',
      dateRange: [
        fromDate,
        toDate
      ]
    }
  },
  created () {
  },
  mounted () {
    this.getData()
  },
  computed: {
    getSigned () {
      if (this.$route.params.signed) {
        return this.$route.params.signed
      }
      return ''
    },
    getCompanyBin () {
      return authorizationAPI.getUsersCompanyBin()
    },
    canCreateTickets () {
      return canCreateTickets(authorizationAPI.getRole())
    },
    isRoleErtys () {
      return authorizationAPI.isRoleErtys()
    },
    isRoleKazykurt () {
      return authorizationAPI.isRoleKazykurt()
    },
    getUsersCompanyBin () {
      return authorizationAPI.getUsersCompanyBin()
    },
    filteredData () {
      return this.data
    },
    getDocumentTypes () {
      if (this.$route.params.types) {
        return this.$route.params.types.split(',')
      }
      return []
    }
  },
  watch: {
    getSigned (val) {
      this.getData()
    }
  },
  methods: {
    sortChange ({ column, prop, order }) {
      console.log(prop, order)
      this.sortBy = prop
      if (order && order.includes('asc')) {
        this.orderBy = 'asc'
      } else if (order && order.includes('desc')) {
        this.orderBy = 'desc'
      } else {
        this.orderBy = ''
        this.sortBy = ''
      }
      this.getData()
    },
    handleSizeChange (event) {
      this.pageSize = event
      this.getData()
      console.log(event)
    },
    handleCurrentChange (event) {
      this.currentPage = event
      this.getData()
      console.log(event)
    },
    isJson (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        console.log('err', e)
        return false
      }
      return true
    },
    getData () {
      this.isLoading = true
      const fromDate = format(new Date(this.dateRange[0]), 'yyyy-MM-dd HH:mm:ss')
      const toDate = format(endOfDay(new Date(this.dateRange[1])), 'yyyy-MM-dd HH:mm:ss')
      blockchainApi.getAgreement(fromDate, toDate, this.getCompanyBin, this.pageSize, this.currentPage, this.getSigned).then(resp => {
        this.totalElements = resp.length
        this.data = resp.filter(item => this.isJson(item.data)).map(item => {
          const dataInfo = JSON.parse(item.data)
          item.companyName = dataInfo.companyName
          item.agreementName = dataInfo.agreementName
          item.agreementNumber = dataInfo.agreementNumber
          item.agreementCreatedDate = date.getFormattedDate(dataInfo.createdDate)
          item.lastStatus = dataInfo.lastStatus
          item.price = dataInfo.price
          item.registryDate = date.getFormattedDate(dataInfo.registryDate)
          item.created = date.getFormattedDate(item.createdAt)
          if (item.status) {
            if (item.status.status === 'CREATED') {
              item.statusName = 'Создан'
            } else if (item.status.status === 'SENDED') {
              item.statusName = 'Отправлен'
            } else if (item.status.status === 'APPROVED') {
              item.statusName = 'Утвержден'
            } else if (item.status.status === 'RECEIVED') {
              item.statusName = 'Доставлен'
            } else if (item.status.status === 'REJECTED') {
              item.statusName = 'Отклонен'
            } else if (item.status.status === 'CANCELED') {
              item.statusName = 'Отменен'
            } else if (item.status.status === 'UPDATED') {
              item.statusName = 'Отредактирован'
            } else if (item.status.status === 'CONFIRMED') {
              item.statusName = 'Подтвержден'
            } else if (item.status.status === 'SIGNED') {
              item.statusName = 'Подписан'
            }
          }
          return item
        })
        documentNotificationsStore.markRead(['agreement'])
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    openDocument (data) {
      this.$router.push({ path: '/company/agreement-detail', query: { hash: data.hash } })
    }
  }
}
</script>

<style>
.pagination {
  margin-top: 30px;
  display: flex;
  justify-content: center
}
.el-table tr {
  cursor: pointer;
}
.el-table .error-row {
  background-color: #ffd8d8;
}
</style>
